import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { PainPoints } from './components/PainPoints';
import { SolutionIntro } from './components/SolutionIntro';
import { TomosAccordion } from './components/TomosAccordion';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { Objections } from './components/Objections';
export function App() {
  return <div className="min-h-screen bg-brand-black font-body selection:bg-brand-green selection:text-brand-black" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <PurchasePopup data-id="element-2" />

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <StatsBar data-id="element-5" />
        <PainPoints data-id="element-6" />
        <SolutionIntro data-id="element-7" />
        <TomosAccordion data-id="element-8" />
        <Bonuses data-id="element-9" />
        <Testimonials data-id="element-10" />
        <Pricing data-id="element-11" />
        <Objections data-id="element-12" />
      </main>

      <footer className="bg-brand-black py-8 text-center border-t border-white/10" data-id="element-13">
        <p className="font-body text-gray-500 text-sm" data-id="element-14">
          © {new Date().getFullYear()} Padel Zurdo Pro. Todos los derechos
          reservados.
        </p>
      </footer>
    </div>;
}